import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useExperimentalSiteUserPersonalization } from '@confluence/targeting/entry-points/useExperimentalSiteUserPersonalization.ts';

const CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';

//THE GA Date of USD, any users onboarding on or after this date are considered new users
const NEW_USER_FROM_DATE = new Date('2025-03-24');

export const useIsNewUser = (): {
	isNewUser: boolean;
} => {
	const { cloudId, userId } = useSessionData();

	const { data, loading, error } = useExperimentalSiteUserPersonalization({
		variables: { cloudId, userId: userId ?? '' },
		skip: !userId || !cloudId,
	});

	if (loading || error) {
		return {
			isNewUser: true,
		};
	}

	const attributes = data?.experimentalSiteUserPersonalization?.attributes;

	const firstActiveValue = attributes?.find(
		({ name }: { name: string }) => name === CONFLUENCE_FIRST_ACTIVE_TRAIT,
	)?.value;

	const firstActiveDate = new Date(firstActiveValue ?? '');
	// Check if the date is invalid. If it is, we assume the user is new
	// and return true to avoid mistakenly showing the onboarding message.
	// Related ticket: https://product-fabric.atlassian.net/browse/USD-698
	const isValidDate = !isNaN(firstActiveDate.getTime());

	if (!isValidDate) {
		return {
			isNewUser: true,
		};
	}

	return {
		isNewUser: Boolean(firstActiveDate >= NEW_USER_FROM_DATE),
	};
};
